import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lib-top-info',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './top-info.component.html',
  styleUrls: ['./top-info.component.scss']
})
export class TopInfoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
